// Module
var code = "<template aria-hidden=\"true\"> <i style=\"float:right\" ess-icon=\"ui:icons.info\" class=\"ess-info-text\" ess-tooltip.bind=\"'ui:messages.info.requiredFieldIndicator' | t\"></i> </template> ";
// Exports
module.exports = code;